import React from "react";
import { KTCard } from "../../../../_metronic/helpers/components/KTCard";
import { KTCardBody } from "../../../../_metronic/helpers/components/KTCardBody";
import { GetAmbarListResponseData } from "../../../../models/response/ambar/GetAmbarListResponse";

interface Props {
    /** Yalnız fiyat bulunamayan siparişler. */
    data: GetAmbarListResponseData[]
}

/**
 * Fiyat bulunamayan siparişler için, taşıma yöntemi ve tarihi uyan en yakın anlaşmalar;
 * her anlaşmanın tutmayan alanları anlaşmadaki ve siparişteki değeriyle birlikte.
 * Böylece "anlaşmam var ama fiyat gelmiyor" durumunda eksiğin nerede olduğu ekrandan görünür.
 */
const PriceCandidates = ({ data }: Props) => {
    if (data.length == 0)
        return null;

    const yol = (item: GetAmbarListResponseData) => {
        const yukleme = [item.loadingCountyName, item.loadingDistrictName].filter(x => x).join('/');
        const teslim = [item.deliverCountyName, item.deliverDistrictName].filter(x => x).join('/');

        return yukleme && teslim ? yukleme + ' → ' + teslim : (yukleme || teslim);
    }

    const baslik = (item: GetAmbarListResponseData) => [
        item.refNo,
        item.customerName,
        yol(item),
        item.ambarVoyage?.vehicleType2Name ? 'Araç Cinsi 2: ' + item.ambarVoyage.vehicleType2Name : ''
    ].filter(x => x).join('  ·  ');

    return (
        <KTCard className="ebbe-card mt-10">
            <KTCardBody>
                <h4 className="mb-2 text-black">Fiyat Bulunamayan Siparişler</h4>

                <div className="text-muted fw-semibold mb-8" style={{ fontSize: 13 }}>
                    Her sipariş için yalnız <b>en az alanı tutmayan</b> anlaşmalar listelenir — çoğu zaman tek alandan
                    elenen, yani aranan tarifeye en yakın olanlar. Tek alandan elenen anlaşma yoksa o siparişteki en
                    küçük sayı neyse o anlaşmalar gösterilir.
                </div>

                <div className="table-responsive">
                    <table className="table align-middle table-row-dashed dataTable no-footer">
                        <thead>
                            <tr className="text-start text-muted fw-bolder text-uppercase">
                                <th style={{ width: 180 }}>Anlaşma Şablonu</th>
                                <th style={{ width: 170 }}>Anlaşma No</th>
                                <th style={{ width: 110 }} className="text-center">Tutmayan</th>
                                <th>Eşleşmeyen Alanlar</th>
                            </tr>
                        </thead>
                        <tbody className="text-gray-600 fw-bold">
                            {
                                data.map(function (item) {
                                    return (
                                        <React.Fragment key={item.ambarId}>
                                            <tr style={{ backgroundColor: '#f1faff' }}>
                                                <td colSpan={4} className="fw-bolder text-gray-800">{baslik(item)}</td>
                                            </tr>
                                            {
                                                (item.priceCandidates ?? []).length == 0 && (
                                                    <tr>
                                                        <td colSpan={4} className="text-muted">{item.priceNotFoundReason ?? 'Uyan anlaşma bulunamadı.'}</td>
                                                    </tr>
                                                )
                                            }
                                            {
                                                (item.priceCandidates ?? []).map(function (aday, sira) {
                                                    return (
                                                        <tr key={item.ambarId + '-' + aday.agreementRefNo + '-' + sira}>
                                                            <td>{aday.schemeName}</td>
                                                            <td>{aday.agreementRefNo}</td>
                                                            <td className="text-center">
                                                                <span className={'badge ' + (aday.mismatchCount <= 1 ? 'badge-light-warning' : 'badge-light-danger')}>
                                                                    {aday.mismatchCount}
                                                                </span>
                                                            </td>
                                                            <td>
                                                                {
                                                                    aday.mismatches.slice(0, 3).map(function (alan, i) {
                                                                        return (
                                                                            <span key={i} className="badge badge-light-danger me-2 mb-1 fw-normal">
                                                                                <span className="fw-bold">{alan.fieldName}</span>
                                                                                &nbsp;— anlaşmada: {alan.expectedValue} · siparişte: {alan.actualValue}
                                                                            </span>
                                                                        )
                                                                    })
                                                                }
                                                                {
                                                                    aday.mismatches.length > 3 && (
                                                                        <span className="badge badge-light me-2 mb-1 fw-normal">
                                                                            +{aday.mismatches.length - 3} alan daha
                                                                        </span>
                                                                    )
                                                                }
                                                            </td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </React.Fragment>
                                    )
                                })
                            }
                        </tbody>
                    </table>
                </div>
            </KTCardBody>
        </KTCard>
    )
}

export default PriceCandidates
